<template>
  <div class="button-container">
    <button
      @mousedown="startPress($event)"
      @mouseup="stopPress($event)"
      @mouseleave="stopPress($event)"
      @touchstart="startPress($event)"
      @touchend="stopPress($event)"
      @touchcancel="stopPress($event)"
      class="mic-button "
      :class="{ active: (isRecording || forceStatus) }"
    >
    <div class="timeline">
      <div class="text-container" v-if="label[status || forceStatus]">
        <h2 v-text="label[status || forceStatus]?.title"></h2>
        <span v-text="label[status || forceStatus]?.text"></span>
      </div>
    </div>
      <svg
      v-if="!isRecording && forceStatus !== 'processing'"
        viewBox="0 0 24 24"
        height="24"
        width="24"
        preserveAspectRatio="xMidYMid meet"
        version="1.1"
        x="0px"
        y="0px"
        enable-background="new 0 0 24 24"
      >
        <title>ptt</title>
        <path
          fill="currentColor"
          d="M11.999,14.942c2.001,0,3.531-1.53,3.531-3.531V4.35c0-2.001-1.53-3.531-3.531-3.531 S8.469,2.35,8.469,4.35v7.061C8.469,13.412,9.999,14.942,11.999,14.942z M18.237,11.412c0,3.531-2.942,6.002-6.237,6.002 s-6.237-2.471-6.237-6.002H3.761c0,4.001,3.178,7.297,7.061,7.885v3.884h2.354v-3.884c3.884-0.588,7.061-3.884,7.061-7.885 L18.237,11.412z"
        ></path>
      </svg>
      <div v-else class="outer-circle">
        <div class="inner-circle"></div>
      </div>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    onAudioRecorded: {
      type: Function,
      required: true
    },
    forceStatus: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      mediaRecorder: null,
      audioChunks: [],
      interval: null,
      isRecording: false,
      holdTimeout: null,
      status: null,
      mediaStream: null,
      label: {
        listening: {
          title: 'Diga seu pedido',
          text: 'Ex: "Eu quero um refrigerante e uma água"'
        },
        processing: {
          title: 'Processando',
          text: 'Estamos selecionando seus itens'
        },
        error: {
          title: 'Opa!',
          text: 'Não conseguimos encontrar o item, tente novamente.'
        },
        nomic: {
          title: 'Acesso ao microfone',
          text: 'Erro ao acessar o microfone'
        }
      }
    }
  },
  async mounted () {
    // Solicite o MediaStream apenas uma vez
    try {
      this.mediaStream = await navigator.mediaDevices.getUserMedia({ audio: true })
    } catch (error) {
      this.status = 'nomic'
      console.error('Erro ao acessar o microfone:', error)
    }
  },
  beforeUnmount () {
    clearInterval(this.interval)
    // Pare o MediaStream quando o componente for destruído
    if (this.mediaStream) {
      this.mediaStream.getTracks().forEach((track) => track.stop())
    }
    document.removeEventListener('touchend', this.stopPress, { capture: true })
    document.removeEventListener('mouseup', this.stopPress, { capture: true })
    document.removeEventListener('touchcancel', this.stopPress, { capture: true })
  },
  methods: {
    async startPress (event) {
      event.preventDefault()
      event.stopPropagation()
      if (!this.status && !this.forceStatus) {
        this.status = 'listening'
        this.holdTimeout = setTimeout(() => {
          if (this.mediaStream) {
            this.mediaRecorder = new MediaRecorder(this.mediaStream)

            this.audioChunks = []
            this.mediaRecorder.ondataavailable = (e) => {
              this.audioChunks.push(e.data)
            }

            this.mediaRecorder.start()

            this.isRecording = true

            document.addEventListener('touchend', this.stopPress, { capture: true })
            document.addEventListener('mouseup', this.stopPress, { capture: true })
            document.addEventListener('touchcancel', this.stopPress, { capture: true })

            this.fallbackTimeout = setTimeout(() => {
              if (this.isRecording) {
                this.stopPress({ type: 'fallback' })
              }
            }, 10000)
          } else {
            this.status = 'nomic'
            console.error('Microfone não acessível ou permissão negada.')
          }
        }, 200)
      }
    },
    stopPress (event) {
      console.log(event)
      if (event.type !== 'fallback') {
        event.stopPropagation()
      }
      clearTimeout(this.holdTimeout)
      clearTimeout(this.fallbackTimeout)
      document.removeEventListener('touchend', this.stopPress, { capture: true })
      document.removeEventListener('mouseup', this.stopPress, { capture: true })
      document.removeEventListener('touchcancel', this.stopPress, { capture: true })
      this.status = null
      if (this.isRecording) {
        if (this.mediaRecorder) {
          this.mediaRecorder.stop()
          this.mediaRecorder.onstop = () => {
            const audioBlob = new Blob(this.audioChunks, { type: 'audio/webm' })
            this.onAudioRecorded(audioBlob)
          }
          this.mediaRecorder = null
        }
        this.isRecording = false
        clearInterval(this.interval)
      }
    }
  }
}
</script>

<style lang="less">
.button-container {
  user-select: none;
  position: fixed;
  bottom: 135px;
  right: 15px;
  z-index: 5;
  .mic-button {
    background: white;
    user-select: none;
    border: none;
    border-radius: 50%;
    width: 70px;
    height: 70px;
    font-size: 24px;
    cursor: pointer;
    position: relative;
    pointer-events: auto;
    box-shadow: 0 4px 8px 0px #00000026;

    svg, .outer-circle {
      transform: translate(-50%, -50%);
      position: absolute;
      user-select: none;
      left: 50%;
      top: 50%;
    }
    svg {
      fill: var(--primaryColor);
    }

    .outer-circle {
      border-radius: 50%;
      animation: colorCycle 5s linear infinite;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 24px;
      height: 24px;
    }

    .inner-circle {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #fff;
      animation: pulse 2s ease-in-out infinite;
    }

    @keyframes colorCycle {
      0% {
        background-color: #111827;
      }
      33% {
        background-color: #599cff;
      }
      66% {
        background-color: #00dbff;
      }
      100% {
        background-color: #111827;
      }
    }

    @keyframes pulse {
      0%, 100% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.5);
      }
    }

    .timeline {
      position: absolute;
      overflow: hidden;
      display: block;
      height: 70px;
      background: white;
      right: 1px;
      top: 0;
      bottom: 0;
      margin: auto;
      z-index: 0;
      width: 70px;
      max-width: 280px;
      border-radius: 64px;
      transition: 0.2s linear width;
      .text-container {
        max-width: calc(100% - 85px);
        margin: 8px 0 0 28px;
        transform-origin: left;
        transform: scaleX(0);
        transition: transform 0.2s linear;
        opacity: 0;
        h2, span {
          font-size: 14px;
          position: relative;
          display: block;
          text-align: left;
          margin: 0;
        }
        span {
          margin-top: 3px;
          font-size: 13px;
          color: #BABABA;
        }
      }
    }
    &.active {
      .timeline {
        width: 277px;
        box-shadow: 0 4px 8px 0px #00000026;
        .text-container {
          transform: scaleX(1);
          opacity: 1;
        }
      }
    }
  }
}
</style>
